export const submitSalesforceForm = (formDataCreator: () => [string, string][], action?: string) => {
    const fields: Record<string, string> = {}
    formDataCreator()
      .forEach(x => fields[x[0]] = x[1])
  
    webToLead(fields, location.href, action)
  }
  
  
  const webToLead = (fields: Record<string, string>, returnUrl: string, action?: string) => {
    const customHiddenIframeName = "JLA_API"
    if (!document.getElementById(customHiddenIframeName)) {
      const iframe = document.createElement("iframe")
      iframe.id = customHiddenIframeName
      iframe.name = customHiddenIframeName
      iframe.src = "about:blank"
      iframe.style.display = "none"
      document.body.appendChild(iframe)
    }
  
    fields["retURL"] = returnUrl
    const form = document.createElement("form")
    form.method = "POST"
    form.action = action ?? "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
    form.setAttribute("target", customHiddenIframeName)
  
    for (const fieldName in fields) {
      const input = document.createElement("input")
      input.name = fieldName
      input.value = fields[fieldName]
      input.setAttribute("type", "hidden")
      form.appendChild(input)
    }
  
    document.body.appendChild(form)
    form.requestSubmit()
  }